import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';

import { ChannelForm } from './channel-form';
import { ChannelSummary } from './channel-summary';

export function CampaignDetails() {
  const { formatCurrency } = useCurrencySymbol();
  const { hookForm, totalBudget } = useJobPostingContext();
  const { watch } = hookForm;
  const channelsFormData = watch('channels');

  return (
    <div className="flex flex-col gap-3">
      {Object.keys(channelsFormData).map(channelSlug => (
        <Fragment key={channelSlug}>
          {watch(`channels.${channelSlug}.isExpanded`) ? (
            <ChannelForm channelSlug={channelSlug} />
          ) : (
            <ChannelSummary channelSlug={channelSlug} />
          )}
        </Fragment>
      ))}

      <div className="bg-fx-neutral-200 h-px w-[640px]" />

      <div className="mr-[64px] flex flex-col items-end gap-2">
        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Total"
            description="Total spend label"
          />
        </Typography>
        <Typography variant="h3">{formatCurrency(totalBudget)}</Typography>
      </div>
    </div>
  );
}
